import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIllustration = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 909,
	height: 807,
	fill: "none",
	viewBox: "0 0 909 807",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 430.3,
			height: 436.5,
			x: 109.4,
			y: 26.5,
			fill: "url(#paint0_linear_25220_10565)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 368.7,
			cy: 404.1,
			r: 53.2,
			fill: "#fdc564"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#f3f3f3",
			d: "M93.4 364.5C281 395 351.4 469 369.8 496.8H93.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#bdbdbd",
			d: "M205.2 496.1h145.5c7.4-23 94.3-68-35.2-63.4-39 1.4-92.6 41.6-110.3 63.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#f3f3f3",
			d: "M562.3 364.5C375 395 294 468.7 275.5 496.5h289l-1.1-66z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#d9d9d9",
			d: "m426.1 427.7 8-7.9c29.4 29.5 89 89.8 91.6 95.2 3.3 6.7-6.4.5-6.2.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#d9d9d9",
			d: "m494.7 492.4 7-2.4c1.7 8.6 5 26.2 4 27.8-1.3 2-1.7 2.1-3.2.3-1.4-2.7-5.2-17-7.8-25.7M482.2 479l3.6-6.6c8 3.3 23.9 10.4 24.3 12 .5 2 .3 2.4-2.3 2.6-3.1-.4-17-5.3-25.6-8m-26.9-29 3.6-6.5c7.9 3.3 23.8 10.4 24.3 12 .5 2 .2 2.4-2.4 2.6-3-.4-17-5.3-25.5-8m12.1 17 7-2.4c1.8 8.6 5 26.2 4 27.8-1.2 2-1.7 2.1-3.2.3-1.4-2.6-5.2-17-7.8-25.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b4031",
			d: "M436.8 427.6h-11.1c0-49.2.5-149.3 2.4-156 2.4-8.4 4.9 4.9 4.9 4.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b4031",
			d: "m434 316.3-6.6-3.7c4.9-8.7 15-26.1 16.9-26.7 2.3-.6 2.7-.3 2.5 2.5-1 3.4-8.5 18.6-12.7 28m-.7 21.6-7.2 2.4c-3.2-9.4-9.5-28.6-8.7-30.3 1-2.1 1.6-2.2 3.5-.2 2 3 8.3 18.7 12.4 28m-1.4 46.7-7.2 2.5c-3.2-9.4-9.5-28.6-8.7-30.3 1-2.2 1.6-2.2 3.5-.2 2 2.9 8.3 18.6 12.4 28m3.5-24.4-6.7-3.8c4.9-8.6 15-26 16.9-26.6 2.3-.6 2.7-.3 2.5 2.4-1 3.4-8.5 18.6-12.7 28"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 438.7,
			height: 481.8,
			x: 105.2,
			y: 20.9,
			stroke: "#fff",
			strokeWidth: 41.7
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 476.2,
			height: 27.8,
			x: 88.6,
			y: 89.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#6b4031",
			strokeWidth: 3.1,
			d: "m241 331.9 16.7-5.6 2 8.7 8.3-19.5m-59.6 16.1-15.4-8.7-3.7 8.1-4.3-20.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#6b4031",
			strokeWidth: 2.1,
			d: "m265 322.4 7.2 8.6M180 314l7 8.6"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 205.4,
			cy: 408.4,
			fill: "#d9d9d9",
			rx: 41.7,
			ry: 9.1,
			transform: "rotate(-9.6 205.4 408.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 224.7,
			cy: 382.2,
			r: 30.5,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 223.7,
			cy: 335.5,
			r: 22.4,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 223.6,
			cy: 298.9,
			r: 15.2,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fa8331",
			d: "m241.3 299.8-9.7-.8a1 1 0 0 0-1 1.5l.8 1.8q.3.6 1 .6l8.9-1c1.2-.2 1.2-2 0-2.1"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 226.7,
			cy: 308,
			r: 1,
			fill: "#232121"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 223.6,
			cy: 306,
			r: 1,
			fill: "#232121"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 229.7,
			cy: 309,
			r: 1,
			fill: "#232121"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 232.8,
			cy: 308,
			r: 1,
			fill: "#232121"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 235.8,
			cy: 305,
			r: 1,
			fill: "#232121"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 224.7,
			cy: 295.8,
			r: 2,
			fill: "#232121"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 233.8,
			cy: 294.8,
			r: 2,
			fill: "#232121"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 602.1,
			height: 54,
			x: 23.1,
			y: 501.6,
			fill: "#674644",
			rx: 9.2
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#a88381",
			d: "M112 520.3c-3.4-1.3 1.5-9.9 4.4-14l9.7 5.4c-3.2 3.4-10.6 10-14 8.6m76.2.2c-2.4 2.9-9-4.6-11.9-8.7l8.3-7.4c2.2 4.2 6 13.3 3.6 16.1"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 150.8,
			cy: 465.2,
			r: 57.2,
			fill: "#9b5d59"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 150.8,
			cy: 465.2,
			r: 43.3,
			fill: "#fff9de"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 151,
			cy: 499.8,
			r: 2.2,
			fill: "#6a3b00"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 185.7,
			cy: 467.3,
			r: 2.2,
			fill: "#6a3b00"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 116.4,
			cy: 467.3,
			r: 2.2,
			fill: "#6a3b00"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 151,
			cy: 429.4,
			r: 2.2,
			fill: "#6a3b00"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "hand-black",
			x1: 150.8,
			x2: 150.8,
			y1: 444.4,
			y2: 463.7,
			stroke: "#6a3b00",
			strokeLinecap: "round",
			strokeWidth: 3.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "hand-red",
			x1: 150.8,
			x2: 150.8,
			y1: 444.4,
			y2: 463.7,
			stroke: "#9d230f",
			strokeLinecap: "round",
			strokeWidth: 3.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 150.8,
			cy: 467.5,
			r: 3.5,
			fill: "#9d230f",
			stroke: "#9d230f",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.9,
			height: 8.1,
			x: 149,
			y: 401.2,
			fill: "#9b5d59"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4.9,
			height: 17.9,
			x: 142.5,
			y: 403.6,
			fill: "#5e3431",
			rx: 1.6,
			transform: "rotate(-90 142.5 403.6)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#cd6b4d",
			d: "M802.2 714c19.6 8.1 42-8.6 43.2-9.2-26.7-14-82.9-42-94-42s-2.3 26.4 3.5 39.7c11.5 5.4 37.3 7.4 47.3 11.5m-335.7-1.7c-19.7 8-43.9-7.5-45-8 26.7-14 84.6-43.3 95.7-43.3 11 0 2.3 26.5-3.4 39.8-11.6 5.4-37.4 7.4-47.3 11.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffbb96",
			d: "M478 813.5c-13 1-.6-144.6-5.6-187.6.5-13 3-40.2 34.9-7.6 40 40.8 18.6 191.8-29.2 195.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e86b6b",
			d: "M447.3 638.4c6-25.8 31.7-114.4 73.8-145.6 12.7-9.4 30.9-8.2 48.8-3.4 18 4.8-11.3 150.4-18.8 214.2-14.9-.3-58.4-23.6-75.7-13.2-25.3 15.4-28.8 16.6-54.3 13.2 1.5-3.2 20.2-39.4 26.2-65.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffbb96",
			d: "M447.9 816.6c18.1 15.6 55.4 0 58.2-37.6 0-54-16.4-235.8-10-255.2 5.7-17-79.6 16-48.2 69.8-7.5 88.5-18.1 207.4 0 223"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e86b6b",
			d: "M499.5 548.6c-9.3-54.3 59.2-76.8 94.6-81.3 49.8-41.6 125.1 4.3 175 27-6.2 42-8.3 109.4-11.9 136.5-9.9 75.2-21.8 128.5-9.7 220.4H535.6c3.9-109-26.7-248.2-36-302.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffbb96",
			d: "M656.6 820.6c-16.4-7.8 87-169.8 107.1-223.4 8.5-15 28-45.1 46.5 14.6 23.2 74.6-94 237-153.6 208.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffce89",
			d: "M701.9 210.5 665.6 238c-26.5 0-258.2 229.7-10.4 277.6C751 534.1 758.2 678 805.8 678c181.2 0 61.7-223.2-10.1-223.2a330 330 0 0 0 22-74c9.6-55.4-64-144.6-115.8-170.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffbb96",
			d: "M588.3 463.3c15.5-12.5 6.2-43.3-3-61.2l90-16.2c-8.1 37.3 2.3 72.6 8.5 77.4 7.8 6 37.3 3.2 51.5 20 11 13-82.1 122.9-109.3 112-21.8-8.6-73.8-92.6-82.3-112 11-4.8 29-7.5 44.6-20"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#f7aa81",
			fillOpacity: .6,
			d: "M615.8 448.3c19.5-6 48.3-30.3 55.4-50.2l-78.9 23.2c3 9.1 5.5 32.5 23.5 27"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffbb96",
			d: "M542.7 329.9c-1.5-25 10-77.2 16-100.2 123-76.9 153.2 25 155 82 21.3-4.4 27.5 11 15.5 31.4-21.6 36.8-34.3 16.6-39 25-3 5.3-12.3 23-18.2 29.8-6 6.8-57.2 28.3-72.4 30-15.2 1.8-24.8-16.3-49.9-43.3-15.9-17.1-11.6-41.7-7-54.7"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 3.1,
			cy: 3.2,
			fill: "#fff",
			rx: 3.1,
			ry: 3.2,
			transform: "matrix(-.998 -.0624 -.058 .9983 706.2 355.5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffce89",
			d: "M548.4 286.5c1.6-20.4 66-49.2 104.1-62.6 14.9 45 32.8 93.4 64.5 87.4s15.6-90.9 4.6-109.7c-8.8-15-44.2-22-60.8-20-57-31.5-91.8 6.7-126.7 47.7-28 32.7-6.7 80.3 7.7 100.2 3.3-11.6 5-22.6 6.6-43"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#e88653",
			strokeLinecap: "round",
			strokeWidth: 2.6,
			d: "M719.2 318.8c5.5-1.9 10.6 3.8 6.1 12.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#e88653",
			strokeLinecap: "round",
			strokeWidth: 2.2,
			d: "M604.3 396.2c-2.6 1.8-10 .5-12.3-3.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#673f3c",
			d: "m631.7 278.1 2.5-6.4q.1-.6.9-.8c15-3.3 30.2 8.9 39 18.7.9 1.2-.4 2.6-1.6 1.8-5-3-11.1-6.6-15.6-8.4a84 84 0 0 0-24-3c-.8 0-1.5-1-1.2-1.9m-45.9-.3-2.7-6.2q-.2-.6-.8-.8c-13.4-3.3-25.7 8.3-32.6 17.8-.8 1.2.5 2.5 1.7 1.6 4-2.9 9-6.2 12.7-7.8 5-2.2 14.7-2.7 20.4-2.7 1 0 1.6-1 1.3-2"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#e88653",
			strokeLinecap: "round",
			strokeWidth: 2.2,
			d: "M592 324.7a39 39 0 0 1-7.3 12c-2.6 2.4-5.1 3.6-4.1 7.3.7 2.8 4.4 3.7 6.1 3.8"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_25220_10565",
			width: 45,
			height: 24,
			x: 582,
			y: 365,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#643d1d",
				d: "M614.3 369.3a112 112 0 0 1-31.7 3c6.8 16.2 19.2 17.7 28.6 15.5 13.5-3 16.1-20.9 15.6-21.9s-4.7 1.6-12.5 3.4"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_25220_10565)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#643d1d",
					d: "M616.3 368c-10 3-29.2 3.8-34.8 3.2 7.2 17 19.6 21 29.5 17.4a34 34 0 0 0 18.5-21.9c-.6-1-11.5 1.1-13.2 1.3"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#d36b6b",
					d: "M620.7 372c15-1.3 17 10.6 16.8 14.6-2.8-2.1-26 .8-36.9 3.3-.4-.5-1.5-2.9 1.3-7 2.2-3.2 13-10.5 18.8-11"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M608.2 378.1c-20.3 3.5-21.4-3.8-21.4-7.7 3.2 1.8 28-2.9 39.7-6.1.5.3 1.4 2.8.7 6.6s-9.4 5.6-19 7.2"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2c2727",
			d: "m655.6 322-.1.7-.5.5h-.7l-.6-.4-1.2-1.3-4.7-4.5c-5.1-5-13.3-7.1-20-2.2l-1.3 1q-.4.3-.7.3l-.7-.2-.3-.7.2-.8 1.3-1.5c6-7.6 19-6.7 25.3 0a13 13 0 0 1 4 9.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2c2727",
			stroke: "#2c2727",
			strokeWidth: 1.1,
			d: "M660 315.7q-4.1.3-7.2-.2-.8 0-.7.8c.9 2.4 2.2 6 2.7 6.1s3.6-3.4 5.7-5.8q.3-.7-.4-.9Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2c2727",
			stroke: "#2c2727",
			strokeWidth: 1.1,
			d: "M656 313q-4 .4-7.1-.2-1 .1-.7.8c1 2 2.8 4.5 3.3 4.6s3-2.1 5-4.2q.3-.8-.4-1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2c2727",
			d: "m553 314.2.2.5q0 .3.4.4h.5q.3 0 .5-.3l1-1a27 27 0 0 1 4-3c5-3 12.5-2.9 16.2 2.7l.8 1.2q0 .3.4.5h.6q.4 0 .4-.4v-.6q0-.8-.4-1.6c-2.9-7.8-13.7-9.8-20.2-5.6a9 9 0 0 0-4.1 5.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2c2727",
			stroke: "#2c2727",
			strokeWidth: 1.1,
			d: "M559.1 306.8q-4.1.1-7.2-.7c-.4-.2-.9.3-.7.7 1 2.6 2.8 6.5 3.3 6.6s3-3.3 5-5.6c.4-.4 0-1-.4-1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2c2727",
			stroke: "#2c2727",
			strokeWidth: 1.1,
			d: "M564.5 305q-4-1-6.8-2.6-.8-.4-1 .5c0 2.4 0 5.4.5 5.7a24 24 0 0 0 7.4-2.6q.6-.6-.1-1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b93939",
			d: "m634.8 605.3-2.5-.2a660 660 0 0 0-4.8 62.7c-1 32-2.1 63.8 0 96 2.6 26.7 5.4 53.4 12 79.6 1.3 4 1.9 8.2 5.4 12l1.6-1.9c-2-2.3-3.1-7-4-10.8-5.5-26-7.5-52.8-9.4-79.4-1.5-31.5 0-63.4 1-95.2a1354 1354 0 0 0 .7-62.8"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 608.7,
			cy: 656.2,
			fill: "#cd6b4d",
			rx: 3.9,
			ry: 4
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 608.7,
			cy: 722,
			fill: "#cd6b4d",
			rx: 3.9,
			ry: 4
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 608.7,
			cy: 787.7,
			fill: "#b93939",
			rx: 3.9,
			ry: 4
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 613.1,
			cy: 648.2,
			fill: "#b93939",
			rx: 3.9,
			ry: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#da9a77",
			fillOpacity: .3,
			d: "M464.6 607.8c23.6 0 28.5-9.9 32.6-22.6l-49.1 4.2c2.1 6.2 2.9 18.4 16.4 18.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e86b6b",
			d: "M846.2 612.6c-6-25.8-31.7-90.3-73.8-121.5-12.6-9.4-30.8-8.1-48.8-3.4-18 4.8-16.9 120.1-9.4 184 15-.3 61.7 5 79 15.4 25.3 15.3 27.5 20.9 53 17.4-1.5-3.2 6-66.1 0-92"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b93939",
			d: "M631.3 602.2c24.3-15.3 71.9-84.8 88.9-119.6 3.6 2.5 15.3-10.3 30.9 4.5 6.4 6.1-13.1 64.5-28.7 73-5.5 3-7.3 3.4-13.4 1.7 2 7 2 10.7-1.6 16.1-8.7 13.2-81 37.5-76.1 24.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e86b6b",
			d: "M708.2 470c-12.2 35.6-57.5 114-74.5 127.5-12 9.6 67.2-13.5 69.6-29.4 1-7 1-10.5.3-12.6 2 1.7 6 2.1 13.6-4.3 13.8-11.7 35.1-59.5 30-66.8s-37.8-17.9-39-14.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b93939",
			d: "M634 605.2c-21.8-19-59-92.4-70.6-129.5-4 2-15.8 3-22 9.4s-5 42.4 7.7 55c4.3 4.2 8.1 10.2 14.3 9.4-3.2 4.7-2.3 13.2 0 17.5 7.8 13.9 73.4 52 70.6 38.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e86b6b",
			d: "M572.1 470.6c7.1 38.7 51.8 116 66.7 135.2 9.8 12.9-71.1-30.5-71.1-47.2 0-7.4.6-11 1.6-13.1-2.4 1.4-6.6 1.2-13.5-6.6-12.6-14.4-16.5-48-10-54.6s22.1-11.7 26.3-13.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#8c524e",
			d: "M404.2 486.7c3.1-5 108.8-12.3 124.2.3-24.8 8.5-91 20.3-124.2-.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b4031",
			d: "M409.3 488.6c14.7-4.4 88.6-6.7 113 0-25 8.5-79.7 20.5-113 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#9b5d59",
			d: "M424.5 588.8c-12.7-16.7-20.9-74-20.3-102.2 20.3 10.4 98 7 124 0-.1 21.8-5.2 89.9-22.6 102.2-20.6 14.5-70.1 9-81.1 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#8c524e",
			d: "M425.7 588.8c22.8-6 44.6 5.6 62.5-7.1 13.1-9.4 8.9-28.9 33.6-32-3.7 22.3-.7 28.1-16.2 39-20.5 14.6-78.2 7.5-79.9 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			fillOpacity: .1,
			d: "M415.7 540.7c0-5.2 2.2-8.3 5.8-4.2s11.6 42.8 11.6 42.8c0 2-.9 5.2-4.6 2.6-4.7-3.2-12.8-33.8-12.8-41.2m-3.1-23.7c0-2.3 1.6-3.7 4.2-1.8 2.5 1.8 2.2 6.6 2.2 6.6 0 .9.5 8.7-2.2 7.5-3.4-1.4-4.2-9.1-4.2-12.3"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 19.1,
			height: 43.9,
			x: 472.3,
			y: 515,
			fill: "#753f3b",
			rx: 3.8
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffbb96",
			d: "M559 568.3c.7 10.5 87.7 128.9 135.4 186.7-1.7 20.3-10.6 62.2-32.1 67.2-27 6.2-141-238.5-142.9-240.5s-14.6-4.2-25.5-6c-14.8-.7-20.4-2.7-21.7-7.4-.6-3.4-.6-4.8-2.6-6-5.2-3.4-4.5-10.1-2.6-12.8-5.8-1.3-5.8-9.4-4.2-12-9.2-4.5-1.5-13.7 0-14 1.4-.3 47.4 1.7 47.8 0 .5-1.7-4.7-13.2-20.4-11.6-12.5 1.2-16.9-5-17.5-8.3l7.3-1.5c41.5-5.2 42.8 5.5 48 9.2s30 43.8 31 57"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M453 435.7c-10.6 17-4.5 24.4 0 25.9-4.6-7 9-25.9 9-35.3s-16.7-23.7 0-36.7c16.6-12.9-18.9-42-18.9-32 0 13.6-1 9.7-29 35.2s52 21.6 38.8 43m26.4-2.4c-2.6 5.3-4.5 8-3.2 27.5-2-4.7-4-15.5-4-21.4s10.4-18.4 0-26.4 14.9-25 14.9-18.8c0 8.4-7.8 5.9 0 15.6 5 6.5-2.5 12.8-7.7 23.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#f8ab82",
			strokeLinecap: "round",
			strokeWidth: 2.3,
			d: "M689.5 763.9c1.3-5.6.8-10.6-3.3-18.4m-179.2-15c1.3-5.5.8-10.6-3.2-18.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#b93939",
			strokeLinecap: "round",
			strokeWidth: 2.3,
			d: "M726 672q3.5-8.7 7-22.6m-206.6 50.2a97 97 0 0 1-2.3-33.4"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 408.2,
			cy: 526.8,
			fill: "#ffbb96",
			rx: 5.2,
			ry: 6.4,
			transform: "rotate(-7.2 408.2 526.8)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 410.1,
			cy: 541.3,
			fill: "#ffbb96",
			rx: 5.2,
			ry: 6.4,
			transform: "rotate(-7.2 410.1 541.3)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 413.1,
			cy: 555.6,
			fill: "#ffbb96",
			rx: 5.2,
			ry: 6.4,
			transform: "rotate(-14.1 413 555.6)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 417.4,
			cy: 567.9,
			fill: "#ffbb96",
			rx: 4,
			ry: 4.9,
			transform: "rotate(-23.8 417.4 567.9)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 220.3,
			cy: 137.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 144.3,
			cy: 133.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 261.3,
			cy: 252.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 277.3,
			cy: 259.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 274.3,
			cy: 133.9,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 324.5,
			cy: 133.4,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 406.3,
			cy: 170.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 137.3,
			cy: 137.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 130.3,
			cy: 279.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 324.3,
			cy: 176.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 310.3,
			cy: 212.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 304.3,
			cy: 313.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 293.3,
			cy: 370.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 165.3,
			cy: 364.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 497.3,
			cy: 359.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 196.3,
			cy: 277.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 477.3,
			cy: 310.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 490.3,
			cy: 252.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 381.2,
			cy: 131.3,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 492.3,
			cy: 131.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 397.3,
			cy: 164.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 479.3,
			cy: 192.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 425.3,
			cy: 200.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 416.3,
			cy: 233.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 448.3,
			cy: 147.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 356.6,
			cy: 225.9,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 332.3,
			cy: 268.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 178.3,
			cy: 180.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 158.3,
			cy: 309.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 257.3,
			cy: 188.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 207.3,
			cy: 222.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 393.3,
			cy: 300.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 146.3,
			cy: 220.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 320.3,
			cy: 70.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 161.3,
			cy: 52.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 227.3,
			cy: 63.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 468.3,
			cy: 52.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 514.3,
			cy: 72.7,
			r: 2.1,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_25220_10565",
			x1: 324.6,
			x2: 262.3,
			y1: 415.3,
			y2: 26.5,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#fdc564" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0093ff"
			})]
		}) })
	]
});
export default SvgIllustration;
